import { Helmet } from "react-helmet-async";
import PageShell from "@/components/PageShell";
import WhyMicrogreens from "@/components/WhyMicrogreens";

const Microgreens = () => (
  <PageShell>
    <Helmet>
      <title>Why Microgreens | Zentra</title>
      <meta name="description" content="Why Zentra puts horse gram microgreens in protein bars — nutrient density, clean energy, recovery and sustainable farming at our Coimbatore indoor farm." />
    </Helmet>
    <WhyMicrogreens />
  </PageShell>
);

export default Microgreens;
